import { render, staticRenderFns } from "./CodeItem.vue?vue&type=template&id=3de46b6f&scoped=true&"
import script from "./CodeItem.vue?vue&type=script&lang=js&"
export * from "./CodeItem.vue?vue&type=script&lang=js&"
import style0 from "./CodeItem.vue?vue&type=style&index=0&id=3de46b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de46b6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
